import LeaveAllocationSummary, { LEAVE_LABELS } from "components/LeaveAllocations/LeaveAllocationSummary";
import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import { fetchFormRequest } from "../../api/form";
import { getFullName } from '../../helpers/functions/employee';
import moment from "moment";

class LeaveDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                employee: null,
                applicationType: null,
                paymentType: null,
                leaveType: null,
                leaveTypeDetail: null,
                startDate: null,
                endDate: null,
                leaveDays: null,
                leavePaidDays: null,
                leaveWithoutPayDays: null,
                date: null,
                timeFrom: null,
                timeTo: null,
                reason: null,
                approvedBy: null,
                createdAt: null,
                updatedAt: null
            }
        }
    }

    componentDidMount() {
        const { instanceId } = this.props;
        if(instanceId) {
            this.fetchForm(instanceId)
        }
    }

    fetchForm = (id) => {
        fetchFormRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {

        const { 
            _id, 
            employee,
            applicationType,
            paymentType,
            leaveType,
            leaveTypeDetail,
            startDate,
            endDate,
            leaveDays,
            leavePaidDays,
            leaveWithoutPayDays,
            date,
            timeFrom,
            timeTo,
            reason,
            approvedBy,
            createdAt, 
            updatedAt
          } = this.state.resource;

        return (
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        Leave & Undertime Form Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.props.goToList()}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                        <div className="typo-line">
                            <div>
                            <p className="category">Instance ID</p>
                            {_id || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Employee</p>
                            {employee ? getFullName(employee) : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Application Type</p>
                            {applicationType || 'N/A'}
                            </div>
                        </div>
                        {applicationType === "leave" &&
                            <div>
                                <div className="typo-line">
                                    <div>
                                    <p className="category">Payment Type</p>
                                    {paymentType || 'N/A'}
                                    </div>
                                </div>
                                <div className="typo-line">
                                    <div>
                                    <p className="category">Leave Type</p>
                                    {LEAVE_LABELS[leaveType] || leaveType || 'N/A'}
                                    </div>
                                </div>
                                <LeaveAllocationSummary allocations={this.state.resource.leaveAllocations || []} days={this.state.resource.leaveDayAllocations || []} />
                                    {leaveType === 'other' && (
                                    <div className="typo-line">
                                        <div>
                                        <p className="category">Details</p>
                                        {leaveTypeDetail || 'N/A'}
                                        </div>
                                    </div>
                                )}
                                <div className="typo-line">
                                    <div>
                                    <p className="category">Start Date</p>
                                    {startDate ? moment.utc(startDate).format('MMMM Do YYYY') : 'N/A'}
                                    </div>
                                </div>
                                <div className="typo-line">
                                    <div>
                                    <p className="category">End Date</p>
                                    {endDate ? moment.utc(endDate).format('MMMM Do YYYY') : 'N/A'}
                                    </div>
                                </div>
                                {paymentType === "withPay" && (
                                    <div>
                                        <div className="typo-line">
                                            <div>
                                            <p className="category">Requested Leave Days</p>
                                            {leaveDays !== null ? leaveDays : 'Calculated from work schedule'}
                                            </div>
                                        </div>
                                        <div className="typo-line">
                                            <div>
                                            <p className="category">Paid Leave Days</p>
                                            {leavePaidDays !== null ? leavePaidDays : leaveDays}
                                            </div>
                                        </div>
                                        <div className="typo-line">
                                            <div>
                                            <p className="category">Leave Without Pay Days</p>
                                            {leaveWithoutPayDays !== null ? leaveWithoutPayDays : 0}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        }
                        {applicationType === "undertime" &&
                            <div>
                                <div className="typo-line">
                                    <div>
                                    <p className="category">Date</p>
                                    {date ? moment(date).format('MMMM Do YYYY') : 'N/A'}
                                    </div>
                                </div>
                                <div className="typo-line">
                                    <div>
                                    <p className="category">Time From</p>
                                    {timeFrom || 'N/A'}
                                    </div>
                                </div>
                                <div className="typo-line">
                                    <div>
                                    <p className="category">Time To</p>
                                    {timeTo || 'N/A'}
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="typo-line">
                            <div>
                            <p className="category">Reason</p>
                            {reason || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Approved By</p>
                            {approvedBy ? getFullName(approvedBy) : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Created At</p>
                            {createdAt ? moment(createdAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Updated At</p>
                            {updatedAt ? moment(updatedAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default LeaveDetails;
